// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2VUl0","legacyBtn":"MutateMid_legacyBtn__ODSk7"};